<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtrowanie
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Dealer</label>
          <v-select
            :value="dealerFilter"
            :options="dealerOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:dealerFilter', val)"
          >
            <template #option="option">
              <strong>{{ option.number }}</strong>&nbsp;{{ option.name }}
            </template>
          </v-select>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Dział</label>
          <v-select
            :value="departmentFilter"
            :options="departmentOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:departmentFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status konta</label>
          <v-select
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
        <b-col
          v-if="isAdmin"
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Poziom dostępu</label>
          <v-select
            :value="roleFilter"
            :options="roleOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:roleFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    dealerFilter: {
      type: [String, null],
      default: null,
    },
    dealerOptions: {
      type: Array,
      required: true,
    },
    departmentFilter: {
      type: [String, null],
      default: null,
    },
    departmentOptions: {
      type: Array,
      required: true,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    roleFilter: {
      type: [String, null],
      default: null,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
